import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogCompleteReportPriceAbusing = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'COMPLETE_REPORT_PRICE_ABUSING',
    });
  }, [logGoodsAnalytics]);
};